import { TickerItem, TickerMove, TickerWrapper } from './styled';

export default function InfoTicker({ data }) {
  const displayData = [...data, ...data];

  return (
    <TickerWrapper>
      <TickerMove>
        {displayData.map((item, idx) => (
          <TickerItem key={idx}>
            <strong>{item.label}</strong>
            <span>{item.value}</span>
          </TickerItem>
        ))}
      </TickerMove>
    </TickerWrapper>
  );
}
